import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from 'shared/modules/material/material.module';
import { BadgeDirective } from 'shared/modules/typography/badge/badge.directive';
import { ChipComponent } from 'shared/modules/typography/chip/chip.component';
import { DateComponent } from 'shared/modules/typography/dates/date.component';
import { HeadingComponent } from 'shared/modules/typography/heading/heading.component';
import { ProjectViewComponent } from 'shared/modules/typography/project/project-view.component';
import { ColorizedTextComponent } from 'shared/modules/typography/small-text/colorized-text.component';
import { FlagIconComponent } from './flag-icon/flag-icon.component';
import { HintComponent } from './hint/hint.component';

@NgModule({
  declarations: [
    HeadingComponent,
    ChipComponent,
    ColorizedTextComponent,
    DateComponent,
    ProjectViewComponent,
    HintComponent,
    BadgeDirective,
    FlagIconComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
  ],
  exports: [
    HeadingComponent,
    ChipComponent,
    ColorizedTextComponent,
    DateComponent,
    ProjectViewComponent,
    HintComponent,
    BadgeDirective,
    FlagIconComponent,
  ],
})
export class TypographyModule {
}
